import React from 'react';
import PropTypes from 'prop-types';
import InformationSVG from '../../ares/assets/images/information-icon.svg';
import './informationMessage.scss';
export const InformationMessage = ({ text, title }) => {
    return (
        <div className="information-box">
            <img src={InformationSVG} alt="info-icon" className="information-box__icon" />
            <div className="information-box__texts">
                {title && <span className="information-box__texts__title">{title}</span>}{' '}
                <span className="information-box__texts__subtext">{text}</span>
            </div>
        </div>
    );
};

InformationMessage.propTypes = {
    text: PropTypes.string,
    title: PropTypes.string,
};
